import React from 'react';
import Select from 'react-select';

const TeamDepartmentModal = ({ isOpen, setIsOpen }) => {
    if (!isOpen) return null;

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Department</h2>
                <form className="oms-modal-form">
                    <div className="oms-form-group">
                        <label htmlFor="service" className="oms-form-label">
                            Department
                        </label>
                        <input type="text" id="service" placeholder="Enter department" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions} placeholder="Select status" />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TeamDepartmentModal;
